import videojs from 'video.js';

function handlePlayerReady() {
    setTimeout(() => {
        const contentElement = this.contentEl();
        contentElement.classList.add('ready');
    }, 250);

    this.on('ended', () => {
        this.currentTime(0);
        this.hasStarted(false);
        this.trigger('ready');
    });
}

export default function videoPlayer() {
    const videoElements = [...document.querySelectorAll('.js-video-player')];

    const options = {
        controls: true,
        preload: 'auto',
        fluid: true,
        controlBar: {
            pictureInPictureToggle: false,
        },
    };

    videoElements.forEach((element) => {
        element.classList.add('video-js');

        videojs(element, options, handlePlayerReady);
    });
}
